import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import PreviewAndUpdateAct from '../../components/preview-and-update-act/PreviewAndUpdateAct.component';
import LawActClient from '../../api-services/law-act/law-act-client';
import { PreviewLawActModel } from '../../models/PreviewLawAct';
import HandlingResponse from '../../../common/handling-response/handlingResponse';
import { UpdateLawActProvider } from '../../context/UpdateLawActContext';

const UpdateLawAct = () => {
    const [actId, setActId] = useSearchParams();
    const [fromWarnings] = useSearchParams();

    var lawActId = actId.get("actId");
    var isUpdatedFromWarnings = fromWarnings.get("fromWarnings");
    
    //podaci pribavljeni na Index stranici se cuvaju u state
    const { state } = useLocation();
    const navigate = useNavigate();

    var lawActClient = new LawActClient();
    const [lawActInfo, setLawActInfo] = useState(new PreviewLawActModel());    

    useEffect(() => {
      if(lawActId) {
        navigate("/regulations/update?actId=" + lawActId + "&fromWarnings=" + isUpdatedFromWarnings, {replace: true});
        getLawAct();
      }
    }, []);

    const getLawAct = async () => {
      var response, res;
      if(!state) {
        response = await lawActClient.getLawAct(lawActId);
        res = HandlingResponse(response);
      }
        if (res != "Error") {
          setLawActInfo({
            lawActBasicDataModel: state ? state.data.lawActBasicDataDto : res.lawActBasicDataDto,
            officialGazetteModel: state ? state.data.officialGazetteDto: res.officialGazetteDto,
            lawActReferenceModel: state ? state.data.lawActReferenceDto: res.lawActReferenceDto,
            lawActOtherDataModel: state ? state.data.lawActOtherDataDto: res.lawActOtherDataDto,
            lawActChangesHistoryModel: state ? state.data.lawActChangesHistoryDto: res.lawActChangesHistoryDto,
            file: state ? state.data.file : res.file,
            files: state ? state.data.files : res.files,
            pictures: state ? state.data.pictures : res.pictures,
          })
        }
        else setLawActInfo(new PreviewLawActModel());
    };
    
  return (
    <div>
       <UpdateLawActProvider>
        <PreviewAndUpdateAct lawActInfo={lawActInfo} actId={lawActId} getLawAct={getLawAct} />
      </UpdateLawActProvider>
    </div>
  )
}

export default UpdateLawAct;
